import { createTheme } from '@mui/material';
import { AppOperator } from '../types/theme.types';

export const OPERATOR_COLORS = {
  [AppOperator.DEFAULT]: {
    primary: '#96aace',
    secondary: '#7a9cc6',
  },
  [AppOperator.TAURON]: {
    primary: '#d22f7c',
    secondary: '#dc004e',
  },
  [AppOperator.ENEA]: {
    primary: '#003087',
    secondary: '#00266e',
  },
} as const;

const getOperatorColors = (operator: AppOperator) => OPERATOR_COLORS[operator];

export const getThemeConfig = (isDarkMode: boolean, operator: AppOperator = AppOperator.DEFAULT) => {
  const colors = getOperatorColors(operator);

  return createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: colors.primary,
      },
      secondary: {
        main: colors.secondary,
      },
      ...(isDarkMode && {
        background: {
          default: '#121212',
          paper: '#1e1e1e',
        },
        text: {
          primary: '#ffffff',
          secondary: 'rgba(255, 255, 255, 0.7)',
        },
      }),
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            scrollbarColor: isDarkMode ? '#6b6b6b #2b2b2b' : '#c1c1c1 #f1f1f1',
            '&::-webkit-scrollbar, & *::-webkit-scrollbar': {
              backgroundColor: isDarkMode ? '#2b2b2b' : '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb, & *::-webkit-scrollbar-thumb': {
              borderRadius: 8,
              backgroundColor: isDarkMode ? '#6b6b6b' : '#c1c1c1',
              minHeight: 24,
            },
            '&::-webkit-scrollbar-thumb:focus, & *::-webkit-scrollbar-thumb:focus': {
              backgroundColor: isDarkMode ? '#959595' : '#a8a8a8',
            },
            '&::-webkit-scrollbar-thumb:active, & *::-webkit-scrollbar-thumb:active': {
              backgroundColor: isDarkMode ? '#959595' : '#a8a8a8',
            },
            '&::-webkit-scrollbar-thumb:hover, & *::-webkit-scrollbar-thumb:hover': {
              backgroundColor: isDarkMode ? '#959595' : '#a8a8a8',
            },
            '&::-webkit-scrollbar-corner, & *::-webkit-scrollbar-corner': {
              backgroundColor: isDarkMode ? '#2b2b2b' : '#f1f1f1',
            },
          },
        },
      },
    },
  });
};
